import {
	memo,
	ReactElement,
	useState
} from "react";
import { sanitizeHtml } from "client/Misc/htmlUtils";
import { newGuid } from "client_legacy/ndaw/guid";
import styles from "./RawHtml.module.less";

export type RawHtmlProps = {
	html: string;
	isInline?: boolean;
};

const RawHtmlInternal = (props: RawHtmlProps): ReactElement => {
	const {
		html,
		isInline = false
	} = props;

	const [stylesScope] = useState<string>(
		(): string => "styles_scope_" + newGuid()
	);

	const sanitizedHtml: string = sanitizeHtml(
		html,
		{
			globalStylesBehavior: {
				kind: "scope-to-selector",
				selector: `#${stylesScope}`
			}
		}
	);

	return isInline
		? (
			<span
				id={stylesScope}
				dangerouslySetInnerHTML={{__html: sanitizedHtml}}
				className={styles.root}
			/>
		)
		: (
			<div
				id={stylesScope}
				dangerouslySetInnerHTML={{__html: sanitizedHtml}}
				className={styles.root}
			/>
		);
};

export const RawHtml = memo(RawHtmlInternal);
RawHtml.displayName = "RawHtml";